import { HYDRATE } from "next-redux-wrapper";
import { ActionsBrands } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storeBrands(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeBrands };

	}
	case ActionsBrands.LOAD_GET_BRANDS:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsBrands.RES_GET_BRANDS:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsBrands.ERR_GET_BRANDS:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeBrands;
